import type { MomentKind } from '../core/moments';

export type MarkerKind = Exclude<MomentKind, 'disengage'> | 'trigger' | 'incident' | 'mode' | 'nearby' | 'change';

export interface Marker {
  readonly kind: MarkerKind;
  readonly time: number;
  readonly label: string;
}

export interface Span {
  readonly start: number;
  readonly end: number;
}

const MARKER_EPSILON_MS = 250;

export const timeToX = (time: number, span: Span, width: number): number =>
  span.end > span.start ? ((time - span.start) / (span.end - span.start)) * width : 0;

export const xToTime = (x: number, span: Span, width: number): number =>
  span.start + (Math.min(width, Math.max(0, x)) / Math.max(1, width)) * (span.end - span.start);

export function nextMarker(markers: readonly Marker[], time: number, direction: 1 | -1): Marker | undefined {
  const sorted = [...markers].sort((a, b) => a.time - b.time);
  return direction > 0
    ? sorted.find((marker) => marker.time > time + MARKER_EPSILON_MS)
    : sorted.reverse().find((marker) => marker.time < time - MARKER_EPSILON_MS);
}
